=<template>
  <base-card class="mb-4" :id="userId">
    <div class="main-block">
      <div class="media-block">
        <img class="search-photo mb-3" :class="{clickable: !searchDisabled}" :src="photo" @click="profNameClick">
        <div v-if="rating.total > 0">
          <div class="rating">
            <span v-for="n in 5" :key="`rating-${n}`">
              <component :is="ratingComponent(n)" font-scale="1.3"></component>&nbsp;
            </span>
            <span class="rating-mobile" v-if="!xlScreen" v-html="`(${rating.total})`"></span>
          </div>
          <label v-if="xlScreen" class="califications" v-html="`${rating.total} ${$t('ratings')}`"></label>
        </div>
        <div v-if="isProfUser && userLoggedIsPatient" class="favourite" @click="toggleFavourite">
          <span v-if="isFavourite"><b-icon-heart-fill></b-icon-heart-fill> {{$t('removeOfMyTeam')}}</span>
          <span v-else><b-icon-heart class="blue"></b-icon-heart> {{$t('addToMyTeam')}}</span>
        </div>
        <div class="mb-4" v-else-if="!isProfUser">
          <base-button @click="showCenterProfs" white>{{$t('showProfessionals')}}</base-button>
        </div>
      </div>
      <div class="info-block">
        <div>
          <span class="search-name" :class="{clickable: !searchDisabled}" @click="profNameClick">{{`${name}${surnames ? ` ${surnames}` : ''}`}}</span>
          <img class="prof-logo ml-3" v-if="showProfLogo" :src="unipromelImg" @click="logoClick" :title="$t('unipromelPopover')">
        </div>
        <ul v-if="specialtiesToShow.length > 0" class="specialties-list mt-2">
          <li v-for="item in specialtiesToShow" class="mr-3 mb-3" :key="item.id" :class="item.id === -1 ? 'clickable' : null" v-on="item.id === -1 ? {click: showMoreSpecialties} : {}" v-html="`${item.id === -1 ? item.name : $i18nHelpers.normalize(item.name)}`"></li>
        </ul>
        <ul v-if="subspecialtiesToShow.length > 0" class="subspecialties-list">
          <b class="inline-block mr-3 mb-3">{{$t('specialistIn')}}:</b> <li v-for="item in subspecialtiesToShow" class="mr-3 mb-3" :key="item.id" :class="item.id === -1 ? 'clickable' : null" v-on="item.id === -1 ? {click: showMoreSubspecialties} : {}" v-html="`${item.id === -1 ? item.name : $i18nHelpers.normalize(item.name)}`"></li>
        </ul>
        <p class="introductory-text" v-if="introductoryText" v-html="introductoryText"></p>
        <div v-if="centersToShow && centersToShow.length > 0" class="mb-3">
          <div v-for="item in centersToShow" :key="item.id">
            <b-icon-geo-alt-fill class="blue"></b-icon-geo-alt-fill> <a class="bold" v-if="item.customPageUrl" :href="$helpers.getCustomPageUrl(item.customPageUrl)" target="_blank" v-html="`${item.town || item.province ? `${item.town || item.province}: ` : ''}${item.center}`"></a>
            <span v-else v-html="`${item.town || item.province ? `${item.town || item.province}: ` : ''}${item.center}`"></span>
          </div>
          <div class="show-more-centers" v-if="showMoreCentersBtn" @click="showMoreCenters" v-html="`${$t('show')} ${centers.length - 1} ${$t('moreCenters')}`"></div>
        </div>
        <div v-else-if="centerTown" class="mb-3">
          <div>
            <b-icon-geo-alt-fill class="blue"></b-icon-geo-alt-fill> <span v-if="centerTown.name" v-html="`${centerTown.name} (${centerTown.province})`"></span><span v-else v-html="$t('noPhysicalLocation')"></span>
          </div>
        </div>
        <ul v-if="languagesToShow.length > 0" class="languages-list">
          <li v-for="item in languagesToShow" class="mr-3 mb-3" :key="item.code">
            <span v-html="item.language" :class="item.code === -1 ? 'clickable' : null" v-on="item.code === -1 ? {click: showMoreLanguages} : {}"></span>
          </li>
        </ul>
        <!-- <div class="mb-5" v-if="attendInsurance">
          <base-button transparent :borderColor="GRAY_COLOUR" :textColor="GRAY_COLOUR" @click="getInsurers">{{$t('showInsurances')}}</base-button>
        </div> -->
        <div class="mt-4" v-if="userLoggedIsProf">
          <search-blocks-professional @showInterconsultationModal="showInterconsultationModal" :hasInterconsultations="consultations.some(item => INTERCONSULTATION === item.id && item.active)" :loggedProfAllowInterconsultations="profWithInterconsultationsActive"></search-blocks-professional>
        </div>
        <div class="service-type mt-4" v-else>
            <search-service-type-block v-for="(item, index) in servicesToShow" :key="`service-block-${index}`" :price="getServicePrice(item.id, item.rate)" :serviceType="item.id" :firstAppointmentPrice="firstAppointmentPrice(item.id, item.firstConsultationPrice)" :nextAvailability="nextAvailability(item.id)" 
            :requestAppointmentTitle="requestAppointmentTitle(item.id)" :action="isProfUser ? () => serviceAction(item.id) : () =>  centerServiceAction(item.id)" :includedInCompanyService="includedInCompanyService(item.id)" :includedInSubscription="includedInSubscription(item.id)" :hasSpecialPrice="hasSpecialPrice" 
            :showOnlyBySubscription="showOnlyBySubscription(item.id)" :copaymentPrice="copaymentPrice(item.id)" :opensaludpassActive="opensaludpassActive" :ratesRangeActive="ratesRangeActive(item.id)"></search-service-type-block>
            <search-service-type-block v-if="showBudget" budget :requestAppointmentTitle="$t('request')" :action="budgetAction"></search-service-type-block>
            <search-service-type-block v-if="diagnosticsTestsBlock" tests :requestAppointmentTitle="$t('request')" :action="testsAction"></search-service-type-block>
            <search-service-type-block v-if="showDefaultBlock && (!xsScreen || servicesToShow.length < 2)" :requestAppointmentTitle="defaultServiceTitle" :showingMoreServices="servicesToShow.length > 0" default :action="defaultServiceAction"></search-service-type-block>
        </div>
        <search-service-type-block class="mt-4" style="max-width: 100%;" v-if="showDefaultBlock && xsScreen && servicesToShow.length >= 2" :showingMoreServices="servicesToShow.length > 0" default hideIcon :action="defaultServiceAction"></search-service-type-block>
      </div>
    </div>
  </base-card>
</template>

<script>
import SearchServiceTypeBlock from './SearchServiceTypeBlock.vue'
import SearchBlocksProfessional from '@/components/webapp/professional/interconsultations/SearchBlocksProfessional.vue'
import { formatSearchDate } from '@/helpers/date.helpers'
import BaseCard from '@/components/base/ui/BaseCard'
import { PROFESSIONAL_MALE_DEFAULT_IMAGE, PROFESSIONAL_FEMALE_DEFAULT_IMAGE, CENTER_DEFAULT_IMAGE } from '@/constants/images'
import { PREVALIDATED } from '@/constants/db/accreditationStates'
import { GP_SPECIALTY_ID, GP_FAMILY_SPECIALTY_ID } from '@/constants/db/specialties'
import { INDIVIDUAL_FLAT_RATE, OPENSALUDPASS_PREMIUM, OPENSALUDPASS, OPENSALUD_PRIME } from '@/constants/db/subscriptionTypes'
import { GRAY_COLOUR } from '@/constants/colours'
import { MALE } from '@/constants/genders'
import { VIDEO, INPLACE, INSURANCE, AT_HOME, CALL, CHAT, IMMEDIATE_VIDEO, SECOND_OPINION, WRITTEN, COMPANIES, BUDGET, INTERCONSULTATION } from '@/constants/consultationTypes'
import patientsRepository from '@/repositories/PatientsRepository'
import { SCREEN_XL_GRID_MAX, SCREEN_XS_GRID } from '@/constants/mediaQueries'
import { getPortal } from '@/helpers/global.helpers'
import appointmentRequestMixin from '@/mixins/appointmentRequest.mixin'

const UNIPROMEL_LOGO = '/static-appopensalud/img/logos/logo-unipromel-azul.png'
const UNIPROMEL_URL = 'https://www.unipromel.es'
const TOGGLE_IS_FAVOURITE = 'toggleIsFavourite'

export default {
    props: {
      profId: String,
      centerId: String,
      rating: Object,
      isFavourite: Boolean,
      customPageUrl: String,
      name: String,
      surnames: String,
      showProfLogo: Boolean,
      specialties: Array,
      subspecialties: Array,
      introductoryText: String,
      centers: Array,
      languages: Array,
      attendInsurance: Boolean,
      photoUri: String,
      gender: String,
      consultations: Array,
      nextInplaceAvailability: Object,
      nextVideoAvailability: Object,
      nextInsuranceAvailability: Object,
      searchDisabled: Boolean,
      servicesPackages: Array,
      patientTPlanaWebmailHired: Boolean,
      patientCompanyServices: Array,
      patientHiredServicesPackages: Array,
      patientHasSpecialPrices: Boolean,
      inplaceFirstAppointmentEnabled: Boolean,
      inplaceFirstAppointmentPrice: Number,
      minorRestricted: Boolean,
      tarifaPlus: Boolean,
      accreditationState: Number,
      selectedService: Number,
      patientInfo: Object,
      centerTown: Object,
      diagnosticsTestsBlock: Boolean,
      profWithInterconsultationsActive: Boolean,
      specialCompanyPriceRatio: Number
    },
    components: {
      BaseCard,
      SearchServiceTypeBlock,
      SearchBlocksProfessional
    },
    mixins: [appointmentRequestMixin],
    data () {
      return {
        calendarServiceName: {
          [INPLACE]: 'inplace',
          [VIDEO]: 'online',
          [INSURANCE]: 'insurance',
          [WRITTEN]: 'webmail',
          [CHAT]: 'webmailExpress',
          [IMMEDIATE_VIDEO]: 'instant',
          [SECOND_OPINION]: 'secondOpinion',
          [CALL]: 'call',
          [AT_HOME]: 'away'
        },
        copaymentServicesNames: {
          [WRITTEN]: 'writtenRate',
          [CHAT]: 'chatRate',
          [VIDEO]: 'videoRate',
          [CALL]: 'callRate'
        },
        insurers: null,
        originalPrice: null,
        PREVALIDATED,
        languagesReduced: [],
        showAllLanguages: false,
        centersReduced: [],
        showAllCenters: false,
        subspecialtiesReduced: [],
        showAllSubspecialties: false,
        specialtiesReduced: [],
        showAllSpecialties: false,
        GRAY_COLOUR,
        INTERCONSULTATION
      }
    },
    mounted () {
      if (this.languagesToShow.length > 1) this.mapLanguagesList()
      if (this.subspecialtiesToShow.length > 1) this.mapSubspecialtiesList()
      if (this.specialtiesToShow.length > 1) this.mapSpecialtiesList()
    },
    computed: {
      showDefaultBlock () {
        return !this.showBudget && (this.customPageUrl || this.accreditationState === PREVALIDATED)
      },
      userId () {
        return this.profId || this.centerId
      },
      isProfUser () {
        return !!this.profId
      },
      photo () {
        return this.photoUri || (this.centerId ? CENTER_DEFAULT_IMAGE : this.gender === MALE || !this.gender ? PROFESSIONAL_MALE_DEFAULT_IMAGE : PROFESSIONAL_FEMALE_DEFAULT_IMAGE)
      },
      unipromelImg () {
        return UNIPROMEL_LOGO
      },
      hasSpecialPrice () {
        return this.patientHasSpecialPrices && this.specialCompanyPriceRatio != null && this.selectedService !== CHAT
      },
      servicesToShow () {
        let result = []
        if (this.diagnosticsTestsBlock || this.showBudget) return result
        if (this.selectedService === INPLACE) {
          result.push(this.consultations.find(item => this.selectedService === item.id))
          let video = this.consultations.find(item => VIDEO === item.id)
          if (video && video.active) result.push(video)
        } else if (this.selectedService === VIDEO) {
          let inplace = this.consultations.find(item => INPLACE === item.id)
          if (inplace && inplace.active) result.push(inplace)
          result.push(this.consultations.find(item => this.selectedService === item.id))
        } else if (this.selectedService) {
          if (this.consultations.some(item => this.selectedService === item.id)) result.push(this.consultations.find(item => this.selectedService === item.id))
        } else {
          let inplaceService = this.consultations.find(item => item.active && item.id === INPLACE)
          let videoService = this.consultations.find(item => item.active && item.id === VIDEO)
          if (inplaceService && this.nextAvailability(INPLACE)) result.push(inplaceService)
          if (videoService && this.nextAvailability(VIDEO)) result.push(videoService)
        }
        return result
      },
      servicesPackagesActive () {
        return this.servicesPackages && this.servicesPackages.length > 0
      },
      companyServices () {
        if (this.patientInfo && this.patientInfo.validCode && this.patientCompanyServices) {
            return {
                [IMMEDIATE_VIDEO]: this.patientCompanyServices.indexOf(IMMEDIATE_VIDEO) > -1,
                [VIDEO]: this.patientCompanyServices.indexOf(VIDEO) > -1,
                [WRITTEN]: this.patientCompanyServices.indexOf(WRITTEN) > -1,
                [CHAT]: this.patientCompanyServices.indexOf(CHAT) > -1,
                [INPLACE]: this.patientCompanyServices.indexOf(INPLACE) > -1,
                [CALL]: this.patientCompanyServices.indexOf(CALL) > -1,
                [AT_HOME]: this.patientCompanyServices.indexOf(AT_HOME) > -1
            }
        } else {
            return {
                [IMMEDIATE_VIDEO]: false,
                [VIDEO]: false,
                [WRITTEN]: false,
                [CHAT]: false,
                [INPLACE]: false,
                [CALL]: false,
                [AT_HOME]: false
            }
        }
      },
      flatRateActive () {
        return !this.isCenterSearch && this.consultations && this.consultations.find(item => item.id === WRITTEN) ? this.consultations.find(item => item.id === WRITTEN).flatRateActive : false
      },
      flatRatePrice () {
        return !this.isCenterSearch && this.consultations && this.consultations.find(item => item.id === WRITTEN) ? this.consultations.find(item => item.id === WRITTEN).flatRatePrice : null
      },
      defaultServiceTitle () {
        return this.$t('request')
      },
      requestCenterAppointmentBaseUrl () {
        return `${this.baseRequestPath}requestAppointment/center/${this.centerId}`
      },
      requestCenterAvailabilityBaseUrl () {
        return `${this.baseRequestPath}requestAvailability/center/${this.centerId}`
      },
      requestBudget () {
        return `/patient/request-form/${this.profId}/${BUDGET}`
      },
      showBudget () {
        return this.profId && (!this.consultations.length || this.consultations.every(item => !item.active) || !this.tarifaPlus)
      },
      baseRequestPath () {
        return `https://${getPortal()}/${this.$i18n.locale}/HomePaciente/#/`
      },
      patientFlatRateHired () {
        return this.patientTPlanaWebmailHired
      },
      opensaludpassActive () {
        return this.patientInfo && [INDIVIDUAL_FLAT_RATE, OPENSALUDPASS_PREMIUM, OPENSALUDPASS, OPENSALUD_PRIME].indexOf(this.patientInfo.subscriptionType) > -1
      },
      xsScreen () {
        return window.innerWidth <= SCREEN_XS_GRID
      },
      xlScreen () {
        return window.innerWidth > SCREEN_XL_GRID_MAX
      },
      languagesToShow () {
        return !this.languagesReduced.length || this.showAllLanguages ? this.languages : this.languagesReduced
      },
      subspecialtiesToShow () {
        return !this.subspecialtiesReduced.length || this.showAllSubspecialties ? this.subspecialties : this.subspecialtiesReduced
      },
      specialtiesToShow () {
        return !this.specialtiesReduced.length || this.showAllSpecialties ? this.specialties : this.specialtiesReduced
      },
      showMoreCentersBtn () {
        return this.centers && this.centers.length > 1 && !this.showAllCenters && !this.xlScreen
      },
      centersToShow () {
        return this.showMoreCentersBtn ? this.centers.slice(0, 1) : this.centers
      },
      userLoggedIsPatient () {
        return this.$store.getters['session/userIsPatient']
      },
      userLoggedIsProf () {
        return this.$store.getters['session/userIsProfessional']
      }
    },
    methods: {
      getServicePrice (serviceId, rate) {
        let result = { currentPrice: null, originalPrice: null }
        const hasSpecialPrice = this.hasSpecialPrice
        if (this.includedInSubscription(serviceId)) {
          result.currentPrice = 0
          return result
        }
        if (this.ratesRangeActive(serviceId)) {
            if (this.getRatesRangeMinPrice(serviceId) !== null) {
                result.currentPrice = this.getRatesRangeMinPrice(serviceId)
                if (hasSpecialPrice) {
                  result.originalPrice = result.currentPrice
                  result.currentPrice = parseFloat((result.currentPrice * this.specialCompanyPriceRatio).toFixed(2))
                }
            }
        } else {
            result.currentPrice = rate || null
            if (hasSpecialPrice) {
              result.originalPrice = result.currentPrice
              result.currentPrice = parseFloat((result.currentPrice * this.specialCompanyPriceRatio).toFixed(2))
            }
        }
        return result
      },
      copaymentPrice (serviceId) {
        if (this.patientInfo && this.patientInfo.validCode && this.patientCompanyServices) {
            let copaymentItem = this.patientInfo.codeSpecialties.find(item => {
              return this.specialties.some(spe => spe.id === GP_SPECIALTY_ID || spe.id === GP_FAMILY_SPECIALTY_ID ? item.specialtyId === GP_SPECIALTY_ID || item.specialtyId === GP_FAMILY_SPECIALTY_ID : spe.id === item.specialtyId) && item.copaymentEnabled
            })
            return copaymentItem && serviceId ? copaymentItem[this.copaymentServicesNames[serviceId]] : null
        }
        return null
      },
      includedInCompanyService (serviceId) {
        let profWithCompaniesActive = this.consultations.some(item => item.id === COMPANIES && item.active)
        let includedForCompanies = this.patientInfo && this.patientInfo.codeSpecialties.some(item => {
          return this.specialties.some(spe => spe.id === GP_SPECIALTY_ID || spe.id === GP_FAMILY_SPECIALTY_ID ? item.specialtyId === GP_SPECIALTY_ID || item.specialtyId === GP_FAMILY_SPECIALTY_ID : spe.id === item.specialtyId)
        })
        return serviceId && this.companyServices[serviceId] && includedForCompanies && profWithCompaniesActive
      },
      includedInSubscription (serviceId) {
        return (this.patientFlatRateHired && (serviceId && (serviceId === WRITTEN || serviceId === CHAT))) || this.serviceIncludedInServicesPackage(serviceId)
      },
      serviceIncludedInServicesPackage (serviceId) {
        return this.patientHiredServicesPackages.some(item => serviceId === INPLACE ? item.inplaceIncluded : serviceId === VIDEO ? item.onlineIncluded : serviceId === IMMEDIATE_VIDEO ? item.instantIncluded : serviceId === WRITTEN ? item.webmailIncluded : serviceId === CHAT ? item.chatIncluded : serviceId === SECOND_OPINION ? item.secondOpinionIncluded : serviceId === AT_HOME ? item.awayIncluded : false)
      },
      serviceSelectedAvailableInServicesPackages (serviceId) {
        return this.servicesPackages.some(item => serviceId === INPLACE ? item.numInplace > 0 || item.numInplace === -1 : serviceId === VIDEO ? item.numVideo > 0 || item.numVideo === -1 : serviceId === IMMEDIATE_VIDEO ? item.numInmediate > 0 || item.numInmediate === -1 : serviceId === WRITTEN ? item.numWebmail > 0 || item.numWebmail === -1 : serviceId === CHAT ? item.numChat > 0 || item.numChat === -1 : serviceId === SECOND_OPINION ? item.numOpinion > 0 || item.numOpinion === -1 : serviceId === AT_HOME ? item.numAway > 0 || item.numAway === -1 : false)
      },
      showOnlyBySubscription (serviceId) {
        if (serviceId && (serviceId === WRITTEN || serviceId === CHAT) && ((this.flatRateActive && !this.patientFlatRateHired) || this.serviceIncludedInServicesPackage(serviceId) || this.serviceSelectedAvailableInServicesPackages(serviceId)) && this.consultations && this.consultations.some(con => con.id === serviceId && !con.active)) {
          return true
        } else if (serviceId) {
          return this.serviceSelectedAvailableInServicesPackages(serviceId) && this.consultations.some(con => con.id === serviceId && !con.active)
        }
        return false
      },
      ratesRangeActive (serviceId) {
        return serviceId && this.consultations && this.consultations.some(con => con.active && con.ratesRange && con.ratesRange.some(rate => rate.typeServiceId === serviceId))
      },
      getRatesRangeMinPrice (serviceId) {
        if (!serviceId) return null
        let ratesRangeItem = this.consultations.find(con => con.active && con.ratesRange && con.ratesRange.some(rate => rate.typeServiceId === serviceId))
        return ratesRangeItem ? Math.min(...ratesRangeItem.ratesRange.map(item => item.price)) : null
      },
      firstAppointmentPrice (serviceId, firstConsultationPrice) {
        if (!serviceId) return null
        if (this.ratesRangeActive(serviceId)) {
          let ratesRangeItem = this.consultations.find(con => con.active && con.ratesRange && con.ratesRange.some(rate => rate.typeServiceId === serviceId && rate.firstConsultationPrice !== null))
          return ratesRangeItem ? Math.min(...ratesRangeItem.ratesRange.map(item => item.firstConsultationPrice)) : null
        } else {
          return serviceId === INPLACE && this.inplaceFirstAppointmentEnabled ? this.inplaceFirstAppointmentPrice : firstConsultationPrice
        }
      },
      nextAvailability (serviceId) {
        let nextAvailability = serviceId && (serviceId === INPLACE ? this.nextInplaceAvailability : serviceId === VIDEO ? this.nextVideoAvailability : serviceId === INSURANCE ? this.nextInsuranceAvailability : null)
        return nextAvailability ? formatSearchDate(nextAvailability.dayTime) : null
      },
      requestAppointmentTitle (serviceId) {
        return serviceId && (serviceId === WRITTEN ? this.$t('sendConsultation') : serviceId === IMMEDIATE_VIDEO || serviceId === CHAT ? this.$t('makeConsultation') : serviceId === CALL ? this.$t('requestCall') : this.$t('requestAppointment'))
      },
      serviceAction (serviceId) {
        if (!this.canRequestAppointment()) {
          return true
        } else if (serviceId && (serviceId === AT_HOME || (!this.nextAvailability(serviceId) && (serviceId === INPLACE || serviceId === VIDEO)))) {
          this.$emit('showAvailabilityRequestEvent', { profId: this.profId, specialties: this.specialties, companyServices: this.companyServices, currentSelectedServiceId: serviceId })
        } else if (serviceId && (serviceId === CHAT || serviceId === WRITTEN || serviceId === IMMEDIATE_VIDEO || serviceId === SECOND_OPINION || serviceId === CALL)) {
          if (this.ratesRangeActive(serviceId)) {
            window.open(this.$helpers.getCustomPageUrl(this.customPageUrl, `/multiprice/${this.calendarServiceName[serviceId]}`))
            return true
          }
          this.goToAppointmentRequestRoute({ profId: this.profId, appointmentType: this.calendarServiceName[serviceId] })
        } else if (serviceId && (serviceId === INPLACE || serviceId === VIDEO || serviceId === INSURANCE)) {
          window.open(this.$helpers.getCustomPageUrl(this.customPageUrl, `/availabilities/${this.calendarServiceName[serviceId]}`))
        }
      },
      centerServiceAction (serviceId) {
        if (!this.canRequestCenterAppointment()) {
          return true
        } else if (serviceId && (serviceId === AT_HOME || serviceId === INPLACE || serviceId === VIDEO)) {
          location.href = this.$helpers.getApiLoginToUrl(this.$apiToken, `${this.requestCenterAvailabilityBaseUrl}/${this.calendarServiceName[serviceId]}`)
        } else if (serviceId) {
          location.href = this.$helpers.getApiLoginToUrl(this.$apiToken, `${this.requestCenterAppointmentBaseUrl}/${this.calendarServiceName[serviceId]}`)
        } else {
          window.open(this.$helpers.getCustomPageUrl(this.customPageUrl, `/availabilities/${this.calendarServiceName[serviceId]}`))
        }
      },
      showInterconsultationModal (interconsultation) {
        this.$emit('showInterconsultationModalEvent', { id: this.profId, name: `${this.name} ${this.surnames} (${this.$i18nHelpers.normalize(this.specialties[0].name)})`, photo: this.photo, interconsultation: interconsultation })
      },
      showMoreLanguages () {
        this.showAllLanguages = true
      },
      showMoreSubspecialties () {
        this.showAllSubspecialties = true
      },
      showMoreSpecialties () {
        this.showAllSpecialties = true
      },
      showMoreCenters () {
        this.showAllCenters = true
      },
      profNameClick () {
        if (!this.searchDisabled && this.customPageUrl && !this.$route.path.includes('professional-network')) {
          window.open(this.$helpers.getCustomPageUrl(this.customPageUrl))
        } else if (this.accreditationState === PREVALIDATED) {
          this.$emit('showProfessionalPrevalidatedEvent', this.profId)
        }
      },
      showCenterProfs () {
        window.open(this.$helpers.getCustomPageUrl(this.customPageUrl, '/professionals'))
      },
      mapLanguagesList () {
        this.$nextTick(() => {
          let languagesListOffset = document.querySelector(`[id='${this.userId}'] ul.languages-list`).offsetWidth
          let languageItems = document.querySelectorAll(`[id='${this.userId}'] ul.languages-list > li`)
          let totalWidth = 0
          let languages = []
          for (let i = 0; i < languageItems.length; i++) {
            let item = languageItems[i]
            let width = item.offsetWidth
            let marginRight = parseInt(getComputedStyle(item).marginRight)
            totalWidth += width + marginRight
            if (totalWidth > languagesListOffset && i >= 1) {
              let languagesInputLength = this.languages.length
              languages[i - 1] = {code: -1, language: `+${languagesInputLength - (languages.length - 1)}`}
              this.languagesReduced = languages
              break
            }
            languages.push(this.languages[i])
          }
        })
      },
      mapSubspecialtiesList () {
        this.$nextTick(() => {
          let listOffset = document.querySelector(`[id='${this.userId}'] ul.subspecialties-list`).offsetWidth
          let items = document.querySelectorAll(`[id='${this.userId}'] ul.subspecialties-list > li`)
          let totalWidth = 0
          let result = []
          let maxRows = 2
          for (let i = 0; i < items.length; i++) {
            let item = items[i]
            let width = item.offsetWidth
            let marginRight = parseInt(getComputedStyle(item).marginRight)
            totalWidth += width + marginRight
            if (totalWidth > listOffset * maxRows && i >= 1) {
              let inputLength = this.subspecialties.length
              result[i - 1] = {id: -1, name: `+${inputLength - (result.length - 1)}`}
              this.subspecialtiesReduced = result
              break
            }
            result.push(this.subspecialties[i])
          }
        })
      },
      mapSpecialtiesList () {
        this.$nextTick(() => {
          let listOffset = document.querySelector(`[id='${this.userId}'] ul.specialties-list`).offsetWidth
          let items = document.querySelectorAll(`[id='${this.userId}'] ul.specialties-list > li`)
          let totalWidth = 0
          let result = []
          let maxRows = 2
          for (let i = 0; i < items.length; i++) {
            let item = items[i]
            let width = item.offsetWidth
            let marginRight = parseInt(getComputedStyle(item).marginRight)
            totalWidth += width + marginRight
            if (totalWidth > listOffset * maxRows && i >= 1) {
              let inputLength = this.specialties.length
              result[i - 1] = {id: -1, name: `+${inputLength - (result.length - 1)}`}
              this.specialtiesReduced = result
              break
            }
            result.push(this.specialties[i])
          }
        })
      },
      toggleFavourite () {
        patientsRepository.toggleFavouriteDoctor(this.profId).then(response => {
          if (response.data) {
            this.$emit(TOGGLE_IS_FAVOURITE, !this.isFavourite)
          } else {
            this.$store.dispatch('showDangerAlert', this.$t('error.try-again'))
          }
        })
      },
      ratingComponent (iteration) {
        return this.rating && iteration <= this.rating.value ? 'b-icon-star-fill' : 'b-icon-star'
      },
      logoClick () {
        window.open(UNIPROMEL_URL)
      },
      canRequestAppointment () {
        if (this.minorRestricted) {
          this.$emit('showMinorRestrictedEvent', true)
          return false
        } else if (!this.tarifaPlus) {
          this.$emit('showTarifaPlusDisabledEvent', this.profId)
          return false
        } else if (this.accreditationState === PREVALIDATED) {
          this.$emit('showProfessionalPrevalidatedEvent', this.profId)
          return false
        }
        return true
      },
      canRequestCenterAppointment () {
        if (!this.tarifaPlus) {
          this.$emit('showTarifaPlusDisabledEvent', this.centerId)
          return false
        }
        return true
      },
      testsAction () {
        this.$emit('showServicesRequestEvent', { userId: this.profId || this.centerId, selectedService: this.$route.query.serviceId })
      },
      budgetAction () {
        this.goToBudgetRequestRoute({ profId: this.profId })
      },
      defaultServiceAction () {
        if (!this.searchDisabled && this.customPageUrl) {
          window.open(this.$helpers.getCustomPageUrl(this.customPageUrl))
        } else if (this.accreditationState === PREVALIDATED) {
          this.$emit('showProfessionalPrevalidatedEvent', this.profId)
        }
      },
      servicesPackagesAction () {
        window.open(`${this.customPageUrl}/${this.$i18n.locale}/packs`)
      },
      getInsurers () {
        this.$emit('showInsurersEvent', this.isProfUser ? this.profId : this.centerId)
      }
    }
}
</script>

<style lang="scss" scoped>
.main-block{
  display: flex;
  flex-direction: row;
  @include screen-xl-grid-max {
    flex-direction: column;
  }
}
.media-block{
  text-align: center;
  flex: 0 0 150px;
}
.info-block{
  flex: fit-content;
  // remove padding when mobile view
  padding-left: 4rem;
  text-align: left;
  @include screen-xl-grid-max  {
    text-align: center;
    padding-left: 0;
  }
}
.search-photo{
  border-radius: 100%;
  padding: 0;
  box-shadow: 14px 14px 25px #0d275029;
  margin: auto;
  margin-bottom: auto;
  max-width: 100%;
  width: 150px;
  height: 150px;
  @include screen-xl-grid-max{
    width: 120px;
    height: 120px;
  }
}
.search-name{
  display: inline-block;
  font-size: 1.5em;
  text-decoration: underline;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #3238C4;
  width: 100%;
  @include screen-xl-grid-max  {
    font-size: 1.2rem;
  }
}
.block{
  display: block;
}
.info-block ul{
  padding-left: initial;
  margin-bottom: 0;
  li{
    display: inline-block;
    text-align: center;
    border: 1px solid $blue;
    color: $blue;
    background-color: transparent;
    border-radius: 23px;
  }
  &.specialties-list{
  li{
    background-color: $blue;
    color: $white;
    padding: 3px 10px;
    font-size: 14px;
    line-height: 26px;
    }
  }
  &.subspecialties-list{
    li{
      padding: 3px 10px;
      font-size: 14px;
      line-height: 26px;
    }
  }
  &.languages-list{
    li{
      color: $gray-400;
      border-color: $gray-400;
      padding: 1px 10px;
      font-size: 13px;
    }
  }
}
.rating{
  text-align: center;
  .b-icon{
    color: $blue;
  }
}
.califications{
  font-size: smaller;
  color: $gray;
}
.blue{
  color: $blue;
}
.favourite{
  font-size: small;
  color: $blue;
  cursor: pointer;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  @include screen-xl-grid-max  {
    margin-top: 0.5rem;
  }
}
.bold{
  font-weight: bold;
}
.prof-logo{
  width: 45px;
  height: 30px;
  cursor: pointer;
}
.service-type{
    display: flex;
    gap: 1.8rem;
    @include screen-xl-grid-max  {
      justify-content: center;
    }
}
.introductory-text{
  margin-top: 0;
  margin-bottom: 1rem;
}
.rating-mobile{
  position: absolute;
}
.show-more-centers{
  cursor: pointer;
  text-decoration: underline;
  color: $blue;
}
.inline-block{
  display: inline-block;
}
.rating-star{
  color: $blue;
}
</style>


// WEBPACK FOOTER //
// src/components/webapp/patient/search/SearchBlock.vue